import moment from 'moment'
import 'moment/locale/zh-tw'
moment.locale('zh-tw')
import mustacheRender from 'libs/mustacheRender.js'
import _cloneDeep  from 'lodash/cloneDeep'
import _isEqual  from 'lodash/isEqual'
import _isEmpty  from 'lodash/isEmpty'
import _trim  from 'lodash/trim'
import _findIndex  from 'lodash/findIndex'
import _uniqBy  from 'lodash/uniqBy'
import _uniq  from 'lodash/uniq'
import _sortedUniq  from 'lodash/sortedUniq'
import _sortBy  from 'lodash/sortBy'
import _join  from 'lodash/join'
import crosstab from 'crosstab'
window._cloneDeep = _cloneDeep
window._isEqual = _isEqual
window._isEmpty = _isEmpty
window._trim = _trim
window._findIndex = _findIndex
window._uniqBy = _uniqBy
window._uniq = _uniq
window._join = _join
window._sortedUniq = _sortedUniq
window._sortBy = _sortBy

class helper {
  constructor() {
    this.moment = moment
    this.init()
  }

  async init() {
    const { default: faker } = await import(
      /* webpackChunkName: "faker" */
      /* webpackPrefetch: true */
      'faker/locale/zh_TW'
    )
    this.faker = faker
    this.crosstab = crosstab
  }

  crosstabBroadcast(key, data) {
    try {
      this.crosstab.broadcast(key, data, null)
    } catch(error) {
      console.warn('device not support crosstab')
    }
  }

  getRecursive(data, key, withoutWarning = false) {
    let result = _cloneDeep(data)
    try {
      let properties = key.split('.')
      if(properties.length == 1) return data[key]
      for(const property of properties) {
        if(result[property] === undefined || result[property] === null) return undefined
        result = result[property]
      }
    } catch (error) {
      if(process.env.NODE_ENV != 'testing') {
        if(!withoutWarning) console.warn(error)
      }
      return undefined
    }
    return result
  }

  setRecursive(data, key, value) {
    let target = data
    try {
      let properties = key.split('.')
      let last = properties.pop()
      for(const property of properties) {
        if(target[property] === undefined) {
          target[property] = {}
        }
        target = target[property]
      }

      if(target === null || target === undefined) {
        target = {}
      }
      target[last] = value
    } catch(error) {
      console.warn(error)
      return data
    }
    return data
  }

  getCountryCodeFromLanguageCode(code, lowercase = false) {
    if(typeof code != 'string') return
    const partials = code.split('-')
    let result = partials.length == 1 ? partials[0] : partials[1]
    if(lowercase) return result.toLowerCase()
    return result
  }

  // logout confirm
  logout(vm) {
    vm.$apopup.base({
      title: vm.i18n('action.logout'),
      content: vm.i18n('confirm.logout'),
      closeLabel: vm.i18n('action.cancel'),
      applyCallback: () => {
        vm.$store.dispatch('token/clean')
        vm.$snotify.success(
          null,
          vm.i18n('logout.success')
        )
      },
    })
  }

  async getCustomVueComponent(component) {
    if(!component) return
    if(typeof component != 'function') return component
    const { default: result } = await component()
    return result
  }

  render(data, variable = {}) {
    return mustacheRender.render(data, variable)
  }

  getSuffixListByDevice() {
    const windowWidth = $(window).width()
    if(windowWidth < 660) return ['middle','small', 'tiny']
    if(windowWidth < 960) return ['middle', 'small', 'tiny']
    if(windowWidth < 1264) return ['large', 'middle', 'small', 'tiny']
    return ['xlarge', 'large', 'middle', 'small', 'tiny']
  }

  // 移除photo list的null項目
  getComputedPhotoList(photos) {
    if(!Array.isArray(photos)) return null
    const validPhotos = photos.filter(photo => !!photo)
    if(validPhotos.length == 0) return null
    return validPhotos
  }

  getPhotoListUrl(photos, suffixList = null) {
    if(!Array.isArray(photos)) return null
    photos = photos.filter(photo => !!photo)
    return this.getPhotoUrl(photos[0], suffixList)
  }

  getPhotoUrl(photo, suffixList = null) {
    if(!photo) return null
    if(photo.url) return photo.url
    if(!photo.size_list) return null
    if(!suffixList) suffixList = this.getSuffixListByDevice()
    const originUrl = photo.size_list.origin.url
    for(const suffix of suffixList) {
      if(photo.size_list[suffix] && photo.size_list[suffix].url) {
        return photo.size_list[suffix].url
      }
    }
    return originUrl
  }

  getPhotoUrlArray(photo) {
    if(!photo) return null
    if(photo.url) return [photo.url]
    if(!photo.size_list) return [photo.size_list]
    let result = []
    for(const suffix in photo.size_list) {
      const photoSizeObject = photo.size_list[suffix]
      if(!photoSizeObject.url) continue
      result.push(photoSizeObject.url)
    }
    return result
  }

  getSize(byte) {
    if(byte < 1024*1024) return `${(byte/1024).toFixed(2)}KB`
    if(byte < 1024*1024*1024) return `${(byte/1024/1024).toFixed(2)}MB`
    return `${(byte/1000/1000/1024).toFixed(2)}GB`
  }

  isImage(file) {
    if(file instanceof File === false) return false
    if(new RegExp(/image\/png/).test(file.type)) return true
    if(new RegExp(/image\/jpg/).test(file.type)) return true
    if(new RegExp(/image\/jpeg/).test(file.type)) return true
    if(new RegExp(/image\/gif/).test(file.type)) return true
    return false
  }

  selectPhoto(vm, type, applyCallback, options = {}) {
    const single = options.single === true
    vm.$apopup.base({
      title: vm.i18n('photo.manager'),
      bodySlot: () => import('modules/photo/components/photoManager/container/popupContainer.vue'),
      width: vm.$isMobile ? '85vw' : '65vw',
      lockType: type,
      applyCallback,
      applyLabel: vm.i18n('photo.action.apply_photo'),
      ...options,
      disabledApply: (data) => {
        if(!Array.isArray(data)) return false
        if(single) return data.length != 1
        return data.length <= 0
      }
    })
  }

  testMailPrompt(vm, send, metaConfig = null) {
    vm.$apopup.prompt({
      width: '400px',
      title: vm.i18n('mail.action.test'),
      content: vm.i18n('mail.action.test.help'),
      disabledApply: (data) => {
        if(typeof data != 'string') return true
        for(const mail of data.split(',')) {
          const isMail = vm.$validator.isEmail(mail)
          if(!isMail) return true
        }
        return false
      },
      applyCallback: send,
      ...metaConfig,
    })
  }

  getCountdown(time) {
    if(!time) return null
    const now = this.moment()
    const diffTime = this.moment(time).diff(now)
    const duration = this.moment.duration(diffTime, 'milliseconds')
    let hours = duration.hours() > 10 ? duration.hours() : `0${duration.hours()}`
    let minutes = duration.minutes() > 10 ? duration.minutes() : `0${duration.minutes()}`
    let seconds = duration.seconds() > 10 ? duration.seconds() : `0${duration.seconds()}`
    let result = seconds
    if(duration.minutes()) result = `${minutes}:${result}`
    if(duration.hours()) result = `${hours}:${result}`
    return result
  }

  afterLoginSuccess(vm, role) {
    this._redirectAfterLoginSuccess(vm)
    if(role == 'user') {
      this._emitLoginSuccessEventAfterLoginSuccess(vm)
    }
  }

  _redirectAfterLoginSuccess(vm) {
    const path = vm.$route.query.path
    if(!path) return
    vm.$router.replace({ path })
  }

  async _emitLoginSuccessEventAfterLoginSuccess(vm) {
    try {
      await vm.$api.userAccount.admin.emitLoginSuccessEvent()
    } catch (error) {
      console.error(error)
    }
  }

  getBreakpointByWidth(width) {
    if(width < 600) return 'xs'
    if(width < 960) return 'sm'
    if(width < 1264) return 'md'
    if(width < 1904) return 'lg'
    return 'xl'
  }

  getDeviceByWidth(width) {
    const breakpoint = this.getBreakpointByWidth(width)
    if(breakpoint == 'xl' || breakpoint == 'lg') return 'desktop'
    if(breakpoint == 'md') return 'tablet'
    if(breakpoint == 'sm' || breakpoint == 'xs') return 'mobile'
    return null
  }

  selectIcon(vm, icon, applyCallback) {
    vm.$apopup.base({
      width: '600px',
      title: vm.i18n('page_category.data.icon'),
      bodySlot: () => import('components/iconSelector/iconSelector.vue'),
      defaultValue: icon,
      disabledApply: data => _isEmpty(_trim(data)),
      applyCallback,
    })
  }
  
  getYoutubeUid(url) {
    if(typeof url != 'string') return null
    const partial = url.split('v=')
    if(typeof partial[1] != 'string') return null
    const uid = partial[1].split('&')[0 ]
    return uid
  }

  getSize(byte) {
    if(byte < 1024*1024) return `${(byte/1024).toFixed(2)}KB`
    if(byte < 1024*1024*1024) return `${(byte/1024/1024).toFixed(2)}MB`
    return `${(byte/1000/1000/1024).toFixed(2)}GB`
  }

  verifyIdentity(vm, success = null, fail = null) {
    vm.$apopup.base({
      title: vm.i18n('user.verify.help.title'),
      bodySlot: () => import('components/adminVerify/adminVerify.vue'),
      disabledApply: (data) => _isEmpty(_trim(data)),
      applyCallback: async password => {
        try {
          await vm.$api.userAccount.admin.verifyIdentity({ password })
          vm.$snotify.success(null, vm.i18n('user.verify-identity.success'))
          if(typeof success === 'function') success()
        } catch (e) {
          console.error(e)
          vm.$snotify.error(null, vm.i18n('user.verify-identity.fail'))
          if(typeof fail === 'function') fail()
        }
      },
    })
  }

  verifyMemberIdentity(vm, success = null, fail = null, cancelCallback = null) {
    vm.$apopup.base({
      title: vm.i18n('member.verify.help.title'),
      bodySlot: () => import('components/adminVerify/adminVerify.vue'),
      disabledApply: (data) => _isEmpty(_trim(data)),
      closeCallback: (isCancel) => {
        if(!isCancel) return
        if(typeof cancelCallback != 'function') return
        cancelCallback()
      },
      applyCallback: async password => {
        try {
          await vm.$api.member.memberConsole.verifyIdentity({ password })
          vm.$snotify.success(null, vm.i18n('member.verify-identity.success'))
          if(typeof success === 'function') success()
        } catch (e) {
          console.error(e)
          vm.$snotify.error(null, vm.i18n('member.verify-identity.fail'))
          if(typeof fail === 'function') fail()
        }
      },
    })
  }

  formRules(vm) {
    return {
      textLengthRule: (value, length) => {
        const error = vm.i18n('base.validation.text_too_less', { min: length })
        if(typeof value != 'string') return error
        if(!vm.$validator.isLength(value, { min: length })) return error
        return true
      },
      requiredRule:(value) => {
        return !_isEmpty(_trim(value)) || vm.i18n('base.validation.required')
      },
      validEmail: value => {
        const error = i18n('base.validation.email.incorrect')
        if(this.validate().validEmail(vm, value) === false) return error
        return true
      },
      hasLettersAndNumber: value => {
        const error = i18n('base.validation.should_contain_letters_and_numeric')
        if(this.validate().hasLettersAndNumber(value) === false) return error
        return true
      },
    }
  }

  validate() {
    return {
      validZip: (vm, value) => {
        if(typeof value != 'string') return false
        if(vm.$validator.isLength(value, { min: 3 }) === false) return false
        if(vm.$validator.isNumeric(value) === false) return false
        return true
      },
      validEmail: (vm, value) => {
        if(typeof value != 'string') return false
        if(vm.$validator.isEmail(value) === false) return false
        return true
      },
      hasLettersAndNumber: value => {
        if(typeof value != 'string') return false
        const LETTERS_PATTEN = /[a-zA-Z]/
        const NUMERIC_PATTEN = /[0-9]/
        const hasLetters = new RegExp(LETTERS_PATTEN, 'g').test(value) == true
        const hasNumeric = new RegExp(NUMERIC_PATTEN, 'g').test(value) == true
        if(!hasLetters) return false
        if(!hasNumeric) return false
        return true
      },
      minText(vm, value, length) {
        if(typeof value != 'string') return false
        return vm.$validator.isLength(value, { min: length })
      }
    }
  }

  /**
   * 取得app端的JavascriptInterface callback
   * 可參考: frontend/src/libs/mockSsoJavascriptInterface
   */
  getAppCallback() {
    if(typeof window.flutter_inappwebview != 'object') {
      console.warn('未偵測到window.flutter_inappwebview物件')
      return async () => {}
    }

    if(typeof window.flutter_inappwebview.callHandler != 'function') {
      console.warn(`window.flutter_inappwebview.callHandler不為function無法使用`)
      return async () => {}
    }

    return window.flutter_inappwebview.callHandler
  }

  delay(second) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve()
      }, second*1000)
    })
  }

  isExpired(expiredAt) {
    if(!expiredAt) return false
    const now = this.moment()
    return this.moment(expiredAt).isBefore(now)
  }

  removeUserInvalidRoles(roles) {
    const invalidRoles = [
      'ROLE_BANNER', 'ROLE_PAGE', 'ROLE_TEXT', 'ROLE_SMS',
    ]
    let result = []
    for(const role of roles) {
      const invalid = invalidRoles.includes(role)
      if(invalid === true) continue
      result.push(role)
    }
    return result
  }

  isTwoValueBothEmpty(a, b) {
    let isAEmpty = a == '' || a == null || a == undefined
    let isBEmpty = b == '' || b == null || b == undefined
    if(!isAEmpty) return false
    if(!isBEmpty) return false
    return true
  }

  isTwoStringEquals(a, b) {
    const isTwoValueBothEmpty = this.isTwoValueBothEmpty(a, b)
    if(isTwoValueBothEmpty) return true
    return a == b
  }
}

export default new helper()